import {
  DittoModel,
  UserModel,
  OrgModel,
  AreaModel,
  StandardModel,
  ExtendModel,
  FootPrinterModal,
  PunchInModel,
  VideoModel,
} from '@vt/models'

export default {
  // 用来存储普通表单的数据
  ditto: DittoModel,
  // 用来存储组织，用户，点位，指标 等特殊 Models
  user: UserModel,
  area: AreaModel,
  org: OrgModel,
  standard: StandardModel,
  footPrinter: FootPrinterModal,
  extend: ExtendModel,
  punchIn: PunchInModel,
  video: VideoModel,
  // multipleUser: UserModel,
  // refs: [
  //   // OrgModel,
  //   UserModel,
  //   // AreaModel,
  //   // StandardModel
  // ],
}
